module.exports = __webpack_public_path__ + "img/verified.fdf68914.svg";